<template>
  <div class="page page-efriends content">
    <div class="page-efriends__top">
      <div class="page-efriends__top-left">
        <h1 class="page__title">{{ str('efriends.title') }}</h1>
        <div class="page-efriends__energy-lines">
          <template v-if="$store.getters.unusedEnergyLines > 0">
            Du hast noch
            <span
              >{{ $store.getters.unusedEnergyLines }} freie Energyline{{
                $store.getters.unusedEnergyLines > 1 ? 's' : ''
              }}.</span
            >
          </template>
          <template v-else> Du hast alle Energylines in Verwendung. </template>

          <template
            v-if="
              $store.getters.hasProduction &&
              $store.getters.openConnectionsAvailable > -1
            "
          >
            <br />Von deiner Anlage
            <span>{{
              $store.getters.openConnectionsAvailable === 1
                ? 'kann noch 1 ' + envVars.VUE_APP_FRIEND_SINGULAR
                : 'können noch ' +
                  $store.getters.openConnectionsAvailable +
                  ' ' +
                  envVars.VUE_APP_FRIEND_PLURAL
            }}</span>
            beziehen.
          </template>
        </div>
      </div>
      <ListAndMapPreview />
    </div>
    <Contributors v-if="$store.getters.contributors.length > 0" />
    <Donatees v-if="$store.getters.donatees.length > 0" />
    <Producers />
    <Consumers v-if="$store.getters.hasProduction" />
  </div>
</template>

<script>
  import ListAndMapPreview from '@/components/efriends/MapPreview'
  import Producers from '@/components/efriends/Producers'
  import Consumers from '@/components/efriends/Consumers'
  import VueScrollTo from 'vue-scrollto'
  import Donatees from '../components/efriends/Donatees'
  import Contributors from '../components/efriends/Contributors'

  export default {
    name: 'page-efriends',
    components: {
      Contributors,
      Donatees,
      ListAndMapPreview,
      Producers,
      Consumers,
    },
    mounted() {
      if (this.cubeConnectionsReceived) {
        // Wait a little before scrolling to the cube to allow the notifications
        // sidebar to close. Otherwise both animations would show at the same
        // time which doesn't feel right and might cause jank on slower devices.
        setTimeout(() => {
          this.scrollToCube()
        }, 500)
      }
      window.VueScroll = VueScrollTo
    },
    computed: {
      envVars: function () {
        return process.env
      },
      cubeConnectionsReceived() {
        return this.$store.getters.cubeConnectionsReceived
      },
    },
    methods: {
      scrollToCube() {
        const cube = window.location.href.match(/#([pc]_[P_0-9]+)/)
        if (!cube || !cube[1]) {
          return
        }
        const domEl = document.getElementById(cube[1])
        if (domEl) {
          VueScrollTo.scrollTo(domEl, 500, { offset: -100 })
        }
      },
    },
    watch: {
      cubeConnectionsReceived: function (newVal, oldVal) {
        if (!oldVal && newVal) {
          // Scroll to requested cube if necessary.
          setTimeout(this.scrollToCube.bind(this), 1000)
        }
      },
      $route: function (to, from) {
        if (
          to.name === 'efriends' &&
          from.name === 'efriends' &&
          to.hash !== from.hash
        ) {
          this.scrollToCube()
        }
      },
    },
  }
</script>

<style lang="scss">
  .page-efriends {
    max-width: $content-page-width;

    .page__title {
      margin-bottom: 0;

      @media (min-width: $bp-sm) {
        margin-top: 0;
      }

      @media (min-width: $bp-md) {
        margin-bottom: spacer(0.25);
      }
    }

    &__top {
      margin-top: spacer(1);

      @media (min-width: $bp-sm) {
        margin-top: spacer(3);
      }

      @media (min-width: $bp-sm) {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }

      &-left {
        @media (min-width: $bp-sm) {
          flex-basis: 50%;
          flex-shrink: 0;
        }
      }
    }

    &__energy-lines {
      margin-bottom: spacer(1);

      @media (min-width: $bp-md) {
        font-size: $font-size-lg;
      }

      span {
        color: $green-dark;
      }
    }
  }
</style>
